export const SET_AUTH_SESSION = "SET_AUTH_SESSION";
export const CLEAR_AUTH_SESSION = "CLEAR_AUTH_SESSION";
export const AUTH_SESSION_STORE = "authSessionStore";